import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsService } from '../core/services/contact-us.service';

@Component({
  selector: 'app-thank-you',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './thank-you.component.html',
  styleUrl: './thank-you.component.css'
})
export class ThankYouComponent {
  constructor(private contactUsService: ContactUsService) {}

  get message() { return this.contactUsService.messageLabels; }
}

